/**
 * Canonical site origin helper.
 *
 * The production deploy may inject `REACT_APP_BASE_URL` pointing at the bare
 * apex host (`https://artecraftindia.com`), which 301-redirects to the `www`
 * host. Canonical, og:url and hreflang URLs must always point at the final,
 * non-redirecting origin — otherwise every canonical resolves through a 301,
 * which Google treats as a soft canonical signal.
 *
 * `normalizeSiteBase` forces the apex → `www` and upgrades to https for the
 * production domain, while leaving non-production hosts (e.g. localhost during
 * development) untouched so local dev keeps working.
 */

const CANONICAL_HOST = "www.artecraftindia.com";
const APEX_HOST = "artecraftindia.com";
const PRODUCTION_FALLBACK = `https://${CANONICAL_HOST}`;

export function normalizeSiteBase(raw?: string): string {
    if (!raw) return PRODUCTION_FALLBACK;
    try {
        const u = new URL(raw);
        if (u.hostname === APEX_HOST || u.hostname === CANONICAL_HOST) {
            u.protocol = "https:";
            u.hostname = CANONICAL_HOST;
            return u.origin; // strips any trailing slash / path
        }
        // Non-production host (localhost, preview deploys, …): leave as-is,
        // just trim a trailing slash for consistent concatenation.
        return raw.replace(/\/+$/, "");
    } catch {
        return PRODUCTION_FALLBACK;
    }
}

/** Normalized site origin (no trailing slash), safe to build canonical URLs from. */
export const SITE_BASE = normalizeSiteBase(process.env.REACT_APP_BASE_URL);
